import {nsFetch} from "/assets/js/utils/fetch";
import { UrlManager } from '../utils/UrlManager';

class Catalog {
    mainContainer;
    productsContainer;
    productsCounter;
    resetBtn;
    applyBtn;
    filterTags;
    filterCategories;
    sortDropdown;
    sortDropdownInput;
    priceMin;
    priceMax;
    moreBtn;
    paginationContainer;
    paginationBtns;
    pageTitle;
    curPage;
    baseUrl;
    baseTaxId;
    baseTaxType;

    urlManager;

    constructor(elm) {
        this.pageTitle = document.querySelector('.catalog-page__title');
        this.mainContainer = elm;
        this.productsContainer = this.mainContainer.querySelector('.catalog-page__content-products-body');
        this.productsCounter = this.mainContainer.querySelector('.catalog-page__content-products-head-title');

        this.resetBtn = this.mainContainer.querySelector('.catalog-page__content-filter-head-reset');
        this.applyBtn = this.mainContainer.querySelector('.catalog-page__content-filter-btn');
        this.filterTags = this.mainContainer.querySelectorAll('.filter-tags input[type="checkbox"]');
        this.filterCategories = this.mainContainer.querySelectorAll('.filter-categories input[type="checkbox"]');
        this.moreBtn = this.mainContainer.querySelector('.catalog-page__content-products-btn-more');
        this.paginationContainer = this.mainContainer.querySelector('.pagination-container');

        this.sortDropdownInput = this.mainContainer.querySelector('#dropdownInput');
        this.sortDropdown = this.mainContainer.querySelector('[data-dropdown]');
        this.priceMin = this.mainContainer.querySelector('[name="price_min"]');
        this.priceMax = this.mainContainer.querySelector('[name="price_max"]');

        this.urlManager = new UrlManager();
        this.baseUrl = this.mainContainer.dataset.baseUrl;
        this.baseTaxId = this.mainContainer.dataset.baseTaxId;
        this.baseTaxType = this.mainContainer.dataset.baseTaxType;
        this.curPage = this.mainContainer.dataset.paged;

        this.init();
        this.initPagination();
        //this.initFiltersFromUrl();
    }

    init() {
        this.sortDropdown.addEventListener('dropdown:change', this.sortChanged);
        this.resetBtn.addEventListener('click', this.resetFilter);
        this.applyBtn.addEventListener('click', this.applyFilter);
        if (this.moreBtn) {
            this.moreBtn.addEventListener('click', this.loadMore);
        }
    }

    initPagination() {
        this.paginationBtns = this.paginationContainer.querySelectorAll('.page-button');

        this.paginationBtns.forEach(elm => elm.addEventListener('click', this._clickPageBtn));
    }

    loadMore = async (e) => {
        e.preventDefault();

        ++this.curPage;
        const filterData = this.getFilterData();

        await this.requestFilter(filterData, true, true);
    }

    _clickPageBtn = async (e) => {
        e.preventDefault();

        const btn = e.target.closest('.page-button');

        if (btn.classList.contains('catalog-page__content-products-pagination-prev')) {
            --this.curPage;
        } else if (btn.classList.contains('catalog-page__content-products-pagination-next')) {
            ++this.curPage;
        } else {
            this.curPage = btn.dataset.page;
            this.urlManager.setUrl(btn.getAttribute('href'));
        }

        const filterData = this.getFilterData();

        await this.requestFilter(filterData, true);

        this.scrollToTop();
    }

    showPreloader() {
        if (!this.productsContainer) return;
        
        // Проверяем, не добавлен ли уже прелоадер
        if (this.productsContainer.querySelector('.catalog-page__content-products-loading')) {
            return;
        }
        
        this.productsContainer.classList.add('is-loading');
        
        // Создаем overlay с прелоадером
        const loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'catalog-page__content-products-loading';
        
        this.productsContainer.appendChild(loadingOverlay);
    }

    hidePreloader() {
        if (!this.productsContainer) return;
        this.productsContainer.classList.remove('is-loading');
        
        // Удаляем прелоадер, если он есть
        const loadingOverlay = this.productsContainer.querySelector('.catalog-page__content-products-loading');
        if (loadingOverlay) {
            loadingOverlay.remove();
        }
    }

    async requestFilter(filterData, clickPage = false, loadMore = false) {
        console.log(this.mainContainer.dataset);
        
        // Показываем прелоадер при любой загрузке
        this.showPreloader();
        
        const response = await nsFetch.doFetch({
            action: 'ns_filter_catalog',
            body: {
                'filter_data': filterData,
                'paged': this.curPage,
                'base_tax_id': this.baseTaxId,
                'base_tax_type': this.baseTaxType,
                'base_url': this.baseUrl,
                'click_page': clickPage
            }
        });

        // Скрываем прелоадер
        this.hidePreloader();

        if (!response.success) {
            notice(
                response.data.message,
                'error'
            );
            
        } else {
            this.productsCounter.innerHTML = response.data.total_html;

            if (loadMore) {
                this.productsContainer.innerHTML += response.data.products_html;
            } else {
                this.productsContainer.innerHTML = response.data.products_html;
            }
            this.paginationContainer.innerHTML = response.data.pagination_html;

            // Скрываем кнопку, если нет товаров или нет следующих страниц
            if (this.moreBtn) {
                if (response.data.total === 0 || (response.data.pagination_html == '') || response.data.total_pages <= this.curPage) {
                    this.moreBtn.classList.add('is-hidden');
                } else {
                    this.moreBtn.classList.remove('is-hidden');
                }
            }

            this.initPagination();
            
            // Переинициализируем обработчики кликов на каунтер после обновления товаров
            if (window.cartInstance) {
                window.cartInstance.reinit();
            }
            
            // Скроллим вверх к фильтру с сеткой товаров после фильтрации (но не при loadMore)
            if (!loadMore) {
                this.scrollToProductsGrid();
            }
        }
    }

    sortChanged = async (e) => {
        const filterData = this.getFilterData();

        this.urlManager.setUrl(this.baseUrl);

        for (const [param, value] of Object.entries(filterData)) {
            if ((param == 'orderby') && (value == 'menu_order')) continue;
            this.changeFilterItemUrlParam(param, value);
        };

        await this.requestFilter(filterData);
    }

    resetFilter = (e) => {
        e.preventDefault();

        this.filterTags.forEach(elm => {
            elm.checked = false;
        });

        this.filterCategories.forEach(elm => {
            elm.checked = false;
        });

        this.resetBtn.classList.add('is-hidden');

        window.location.href = this.baseUrl;
    }

    applyFilter = async (e) => {
        e.preventDefault();

        // Добавляем прелоадер
        if (this.applyBtn) {
            this.applyBtn.classList.add('is-loading');
        }

        try {
            const filterData = this.getFilterData();

            this.urlManager.setUrl(this.baseUrl);

            for (const [param, value] of Object.entries(filterData)) {
                if ((param == 'orderby') && (value == 'menu_order')) continue;
                this.changeFilterItemUrlParam(param, value);
            };

            await this.requestFilter({
                'f_tags': filterData.f_tags,
                'f_cats': filterData.f_cats,
                'f_price': filterData.f_price,
                'orderby': filterData.orderby
            });

            if (
                (filterData.f_tags != '') ||
                (filterData.f_cats != '') ||
                (filterData.f_price != '')
            ) {
                this.resetBtn.classList.remove('is-hidden');
            }

            if (this.applyBtn.classList.contains('is-mobile')) {
                const filterModal = document.getElementById("filter-modal");
                this.closeMblFilter(filterModal);
            }
        } finally {
            // Убираем прелоадер
            if (this.applyBtn) {
                this.applyBtn.classList.remove('is-loading');
            }
        }
    }

    closeMblFilter(filterModal) {
        const closeEvent = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
        });
        filterModal.dispatchEvent(closeEvent);
    }

    getFilterData() {
        return {
            'f_tags': this.getSelectedFilterItemValues(this.filterTags),
            'f_cats': this.getSelectedFilterItemValues(this.filterCategories),
            'f_price': this.getSelectedFilterPriceValues(),
            'orderby': this.sortDropdownInput.value
        }
    }

    getSelectedFilterPriceValues() {
        if ((this.priceMin.value != this.priceMin.min) || (this.priceMax.value != this.priceMax.max)) {
            return this.priceMin.value + ',' + this.priceMax.value;
        } else {
            return '';
        }
    }

    getSelectedFilterItemValues(elements) {
        return Array.from(elements)
            .filter(elm => elm.checked)
            .map(elm => elm.value)
            .join(',');
    }

    changeFilterItemUrlParam(param, values) {
        if (values != '') {
            this.urlManager.setUrlParam(param, values);
        } else {
            this.urlManager.removeUrlParam(param);
        }
    }

    scrollToTop = () => {
        const header = document.querySelector('header.header');
        const offsetY = header.getBoundingClientRect().height; 
        const position = this.pageTitle.getBoundingClientRect().top + window.scrollY - offsetY;

        window.scrollTo({ top: position, behavior: "smooth" });
    }

    scrollToProductsGrid = () => {
        // Находим контейнер с фильтром и сеткой товаров
        const productsSection = this.mainContainer.querySelector('.catalog-page__content');
        if (!productsSection) return;
        
        const header = document.querySelector('header.header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const position = productsSection.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

        window.scrollTo({ top: position, behavior: "smooth" });
    }

    initFiltersFromUrl() {
        // Получаем параметры из URL
        const urlParams = new URLSearchParams(window.location.search);
        const fTags = urlParams.get('f_tags');
        const fCats = urlParams.get('f_cats');
        const fPrice = urlParams.get('f_price');
        // Параметр сортировки может быть в разных форматах
        const order = urlParams.get('orderby') || this.sortDropdownInput?.value || 'popularity';

        // Проверяем, есть ли параметры фильтров в URL
        const hasFilters = fTags || fCats || fPrice;
        
        // Если есть параметры фильтров в URL, применяем их
        if (hasFilters) {
            // Устанавливаем чекбоксы тегов
            if (fTags) {
                const tagIds = fTags.split(',');
                this.filterTags.forEach(checkbox => {
                    if (tagIds.includes(checkbox.value)) {
                        checkbox.checked = true;
                    }
                });
            }

            // Устанавливаем чекбоксы категорий
            if (fCats) {
                const catIds = fCats.split(',');
                this.filterCategories.forEach(checkbox => {
                    if (catIds.includes(checkbox.value)) {
                        checkbox.checked = true;
                    }
                });
            }

            // Устанавливаем цену
            if (fPrice) {
                const prices = fPrice.split(',');
                if (prices.length === 2) {
                    if (this.priceMin) this.priceMin.value = prices[0];
                    if (this.priceMax) this.priceMax.value = prices[1];
                }
            }

            // Устанавливаем сортировку
            if (order && this.sortDropdownInput) {
                this.sortDropdownInput.value = order;
                // Обновляем текст в dropdown, если есть
                const dropdown = this.sortDropdown;
                if (dropdown) {
                    const option = dropdown.querySelector(`[data-option-value="${order}"]`);
                    if (option) {
                        const title = option.getAttribute('data-option-label') || option.textContent.trim();
                        const titleEl = dropdown.querySelector('[data-sort-title]');
                        if (titleEl) {
                            titleEl.textContent = title;
                        }
                    }
                }
            }

            // Применяем фильтры (используем небольшую задержку для гарантии, что все элементы готовы)
            setTimeout(() => {
                const filterData = this.getFilterData();
                this.requestFilter({
                    'f_tags': filterData.f_tags,
                    'f_cats': filterData.f_cats,
                    'f_price': filterData.f_price,
                    'order': filterData.orderby
                }, false, false);
            }, 100);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.catalog-page');
    if (elm) {
        new Catalog(elm);
    }
});

